import userflow from "userflow.js";

const USERFLOW_TOKEN = process.env.NEXT_PUBLIC_USERFLOW_TOKEN;

let isInitialized = false;

const initializeUserflow = () => {
  if (!USERFLOW_TOKEN) {
    console.warn("Userflow token not found");
    return;
  }

  try {
    userflow.init(USERFLOW_TOKEN);
    isInitialized = true;
    console.log("Userflow initialized successfully");
  } catch (error) {
    console.error("Failed to initialize Userflow:", error);
  }
};

// Initialize Userflow when the module is loaded
if (typeof window !== "undefined") {
  initializeUserflow();
}

const Userflow = {
  identify: async (userId: string, traits?: Record<string, any>) => {
    if (!isInitialized) {
      console.warn("Userflow not initialized");
      return;
    }

    try {
      await userflow.identify(userId, traits);
      console.log("Userflow identify successful:", userId);
    } catch (error) {
      console.error("Userflow identify failed:", error);
    }
  },
};

export default Userflow;
